<template>
  <TreeChart :json="data" />
</template>
<style>
.person {
  width: 15em;
}
.node .person .name {
  word-break: break-all;
  overflow: auto;
  width: 250px;
  height: auto !important;
  line-height: 14px !important;
}
.avat {
  border-radius: 50%;
}
.avat img{
  border-radius:50%;
    -webkit-border-radius:50%;
    -moz-border-radius:50%;
}
</style>
<script>
import moment from 'moment'
import TreeChart from 'vue-tree-chart'

export default {
  name: 'OC',
  components: {
    TreeChart
  },
  props: ['team'],
  watch: {
    team: function() {
      this.loadData()
    }
  },
  data () {
    return {
      data: null
    }
  },
  methods: {
    loadData: function() {
      let that = this
      this.$http.get(this.API3_PREFIX + 'oc?team=' + this.team).then(function (response) {
    if (response.data.length > 0)
      that.data = response.data[0]
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>